import { useState } from 'react'
import {
	EuiFieldSearch,
	EuiFilterGroup,
} from '@equipmentshare/ds2'
import useInputDebounce from 'hooks/useInputDebounce'

export type RequestNumberFilterProps = {
	/**
	 * Seeds the input on mount. The view unmounts when a request is opened, so
	 * this is what restores the typed value on back-navigation.
	 */
	initialValue?: string,
	onChange: ( requestNumber: string ) => void,
}

/** Strip an optional "REQ-" prefix (case-insensitive) so only the number is stored. */
function cleanRequestNumber( input: string ): string {
	return input.trim().replace( /^REQ-/i, '' )
}

export default function RequestNumberFilter( { initialValue = '', onChange }: RequestNumberFilterProps ) {
	const [ inputValue, setInputValue ] = useState( initialValue )

	useInputDebounce( inputValue, 300, ( debounced: string ) => {
		onChange( cleanRequestNumber( debounced ) )
	} )

	return (
		<EuiFilterGroup>
			<EuiFieldSearch
				placeholder="REQ-#"
				value={inputValue}
				onChange={( e ) => setInputValue( e.target.value )}
				style={{ width: 150 }}
			/>
		</EuiFilterGroup>
	)
}
